var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.88672 4.7627C4.09107 4.7627 3.32801 5.07877 2.7654 5.64138C2.20279 6.20398 1.88672 6.96705 1.88672 7.7627V16.7627C1.88672 17.5583 2.20279 18.3214 2.7654 18.884C3.32801 19.4466 4.09107 19.7627 4.88672 19.7627H13.1367C13.9324 19.7627 14.6954 19.4466 15.258 18.884C15.8206 18.3214 16.1367 17.5583 16.1367 16.7627V7.7627C16.1367 6.96705 15.8206 6.20398 15.258 5.64138C14.6954 5.07877 13.9324 4.7627 13.1367 4.7627H4.88672ZM20.3267 19.0127L17.6367 16.3227V8.2027L20.3267 5.5127C21.2707 4.5677 22.8867 5.2367 22.8867 6.5727V17.9527C22.8867 19.2887 21.2707 19.9577 20.3267 19.0127Z",
    fill: "#0A122A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6422d81098bf96560acbfb6bda4a0035.svg";
export { ForwardRef as ReactComponent };